import { useState } from "react";
import { DataTable } from "../components/DataTable";

type Payment = {
  id: string;
  orderId: string;
  customer: string;
  amount: number;
  method: "UPI" | "Card" | "NetBanking" | "COD" | "Wallet";
  status: "Paid" | "Pending" | "Failed" | "Refunded";
  date: string;
  txnId: string;
};

const initialPayments: Payment[] = [
  { id: "pay1", orderId: "#NSJ1042", customer: "Priya Sharma",    amount: 4599,  method: "UPI",        status: "Paid",     date: "2026-05-19", txnId: "TXN9823451" },
  { id: "pay2", orderId: "#NSJ1041", customer: "Anjali Mehta",    amount: 12800, method: "Card",       status: "Paid",     date: "2026-05-18", txnId: "TXN9823312" },
  { id: "pay3", orderId: "#NSJ1040", customer: "Sunita Rao",      amount: 3299,  method: "Wallet",     status: "Pending",  date: "2026-05-18", txnId: "TXN9823099" },
  { id: "pay4", orderId: "#NSJ1039", customer: "Meera Joshi",     amount: 8750,  method: "NetBanking", status: "Paid",     date: "2026-05-17", txnId: "TXN9822987" },
  { id: "pay5", orderId: "#NSJ1038", customer: "Kavya Nair",      amount: 2100,  method: "COD",        status: "Pending",  date: "2026-05-17", txnId: "TXN9822800" },
  { id: "pay6", orderId: "#NSJ1037", customer: "Divya Singh",     amount: 5400,  method: "UPI",        status: "Failed",   date: "2026-05-16", txnId: "TXN9822651" },
  { id: "pay7", orderId: "#NSJ1036", customer: "Ritu Agarwal",    amount: 7300,  method: "Card",       status: "Refunded", date: "2026-05-15", txnId: "TXN9822512" },
  { id: "pay8", orderId: "#NSJ1035", customer: "Pooja Iyer",      amount: 9900,  method: "UPI",        status: "Paid",     date: "2026-05-14", txnId: "TXN9822399" },
];

const STATUS_META: Record<Payment["status"], { color: string; bg: string; icon: string }> = {
  Paid:     { color: "#16a34a", bg: "#dcfce7", icon: "bi-check-circle-fill" },
  Pending:  { color: "#d97706", bg: "#fef3c7", icon: "bi-clock-fill" },
  Failed:   { color: "#dc2626", bg: "#fee2e2", icon: "bi-x-circle-fill" },
  Refunded: { color: "#7c3aed", bg: "#ede9fe", icon: "bi-arrow-counterclockwise" },
};

const METHOD_META: Record<Payment["method"], { icon: string; color: string }> = {
  UPI:        { icon: "bi-phone", color: "#059669" },
  Card:       { icon: "bi-credit-card", color: "#2563eb" },
  NetBanking: { icon: "bi-bank", color: "#0891b2" },
  COD:        { icon: "bi-cash-coin", color: "#d97706" },
  Wallet:     { icon: "bi-wallet2", color: "#7c3aed" },
};

const STYLES = `
  .pay-stats { display:grid; grid-template-columns:repeat(auto-fit,minmax(150px,1fr)); gap:14px; margin-bottom:4px; }
  .pay-stat-card { background:#fff; border:1px solid #f0ebe4; border-radius:16px; padding:18px 20px; box-shadow:0 2px 8px rgba(26,18,8,.06); }
  .pay-stat-label { font-size:11px; font-weight:700; color:#9b8878; text-transform:uppercase; letter-spacing:.6px; margin-bottom:6px; }
  .pay-stat-val { font-size:22px; font-weight:800; color:#1a1208; }
  .pay-stat-sub { font-size:11px; color:#b0a090; margin-top:2px; }

  .pay-card { background:#fff; border-radius:16px; border:1px solid #f0ebe4; box-shadow:0 2px 12px rgba(26,18,8,.07); overflow:hidden; }
  .pay-card-head { display:flex; align-items:center; justify-content:space-between; padding:16px 22px; border-bottom:1.5px solid #f5f0eb; background:linear-gradient(135deg,#1a1208 0%,#2d1e0f 100%); flex-wrap:wrap; gap:10px; }
  .pay-card-title { font-size:15px; font-weight:800; color:#fff; display:flex; align-items:center; gap:8px; }
  .pay-filter-row { display:flex; align-items:center; gap:8px; flex-wrap:wrap; }
  .pay-filter-select { padding:6px 10px; border:1.5px solid rgba(255,255,255,.15); border-radius:8px; background:rgba(255,255,255,.07); color:#fff; font-size:12px; font-family:inherit; outline:none; cursor:pointer; }
  .pay-filter-select option { background:#1a1208; }

  .pay-status-badge { display:inline-flex; align-items:center; gap:5px; padding:3px 10px; border-radius:20px; font-size:12px; font-weight:700; }
  .pay-method-chip { display:inline-flex; align-items:center; gap:5px; font-size:12.5px; font-weight:600; }

  .pay-refund-btn { padding:5px 12px; border-radius:8px; border:1.5px solid #ede6df; background:#fdf8f3; color:#b84008; font-size:11.5px; font-weight:700; cursor:pointer; font-family:inherit; transition:all .15s; }
  .pay-refund-btn:hover { background:#b84008; color:#fff; border-color:#b84008; }
  .pay-refund-btn:disabled { opacity:.4; cursor:not-allowed; }

  .pay-modal-overlay { position:fixed; inset:0; background:rgba(26,18,8,.52); backdrop-filter:blur(4px); z-index:1000; display:flex; align-items:center; justify-content:center; padding:24px; animation:pmFadeIn .2s ease; }
  @keyframes pmFadeIn { from{opacity:0} to{opacity:1} }
  .pay-modal { background:#fff; border-radius:20px; width:100%; max-width:480px; box-shadow:0 24px 64px rgba(26,18,8,.22); animation:pmSlide .25s cubic-bezier(.34,1.56,.64,1); overflow:hidden; }
  @keyframes pmSlide { from{opacity:0;transform:translateY(24px) scale(.97)} to{opacity:1;transform:none} }
  .pay-modal-head { display:flex; justify-content:space-between; align-items:center; padding:20px 24px; border-bottom:1.5px solid #f0ebe4; background:linear-gradient(135deg,#1a1208,#2d1e0f); }
  .pay-modal-title { font-size:15px; font-weight:800; color:#fff; }
  .pay-modal-close { width:30px; height:30px; border-radius:8px; border:1.5px solid rgba(255,255,255,.15); background:transparent; color:#fff; cursor:pointer; font-size:16px; display:flex; align-items:center; justify-content:center; }
  .pay-modal-body { padding:22px 24px; }
  .pay-detail-row { display:flex; justify-content:space-between; align-items:center; padding:10px 0; border-bottom:1px solid #f5f0eb; }
  .pay-detail-row:last-child { border-bottom:none; }
  .pay-detail-label { font-size:12px; color:#9b8878; font-weight:600; }
  .pay-detail-val { font-size:13px; color:#1a1208; font-weight:700; }
  .pay-modal-foot { padding:14px 24px; border-top:1.5px solid #f0ebe4; display:flex; justify-content:flex-end; gap:10px; background:#fdf8f3; }
  .pay-btn-cancel { padding:9px 16px; border-radius:10px; border:1.5px solid #ede6df; background:#fff; font-size:13px; font-weight:600; color:#7a6652; cursor:pointer; font-family:inherit; }
  .pay-btn-confirm { padding:9px 20px; border-radius:10px; border:none; background:linear-gradient(135deg,#d4551a,var(--theme)); color:#fff; font-size:13px; font-weight:700; cursor:pointer; font-family:inherit; }

  .pay-txn { font-family:monospace; font-size:12px; color:#7a6652; background:#f5f0eb; padding:2px 7px; border-radius:5px; }
`;

export function PaymentsPage() {
  const [payments, setPayments] = useState<Payment[]>(initialPayments);
  const [filterStatus, setFilterStatus] = useState("All");
  const [filterMethod, setFilterMethod] = useState("All");
  const [refundTarget, setRefundTarget] = useState<Payment | null>(null);

  const filtered = payments.filter(p =>
    (filterStatus === "All" || p.status === filterStatus) &&
    (filterMethod === "All" || p.method === filterMethod)
  );

  const totalCollected = payments.filter(p => p.status === "Paid").reduce((s, p) => s + p.amount, 0);
  const totalPending   = payments.filter(p => p.status === "Pending").reduce((s, p) => s + p.amount, 0);
  const totalRefunded  = payments.filter(p => p.status === "Refunded").reduce((s, p) => s + p.amount, 0);
  const totalFailed    = payments.filter(p => p.status === "Failed").length;

  function doRefund() {
    if (!refundTarget) return;
    setPayments(prev => prev.map(p => p.id === refundTarget.id ? { ...p, status: "Refunded" } : p));
    setRefundTarget(null);
  }

  const cols = [
    { key: "txnId",    label: "Txn ID",   render: (row: Payment) => <span className="pay-txn">{row.txnId}</span> },
    { key: "orderId",  label: "Order",    render: (row: Payment) => <span style={{ fontWeight: 700, color: "var(--theme)" }}>{row.orderId}</span> },
    { key: "customer", label: "Customer", render: (row: Payment) => row.customer },
    { key: "method",   label: "Method",   render: (row: Payment) => {
      const m = METHOD_META[row.method];
      return <span className="pay-method-chip"><i className={`bi ${m.icon}`} style={{ color: m.color }}></i>{row.method}</span>;
    }},
    { key: "amount",   label: "Amount",   render: (row: Payment) => <strong>₹{row.amount.toLocaleString("en-IN")}</strong> },
    { key: "date",     label: "Date",     render: (row: Payment) => row.date },
    { key: "status",   label: "Status",   render: (row: Payment) => {
      const s = STATUS_META[row.status];
      return <span className="pay-status-badge" style={{ color: s.color, background: s.bg }}><i className={`bi ${s.icon}`}></i>{row.status}</span>;
    }},
    { key: "id", label: "Action", render: (row: Payment) =>
      <button className="pay-refund-btn" disabled={row.status !== "Paid"} onClick={() => setRefundTarget(row)}>
        <i className="bi bi-arrow-counterclockwise"></i> Refund
      </button>
    },
  ];

  return (
    <div className="d-grid gap-3">
      <style>{STYLES}</style>

      {/* Stats */}
      <div className="pay-stats">
        {[
          { label: "Total Collected", val: `₹${totalCollected.toLocaleString("en-IN")}`, sub: `${payments.filter(p => p.status === "Paid").length} transactions`, icon: "bi-check-circle-fill", color: "#16a34a" },
          { label: "Pending",         val: `₹${totalPending.toLocaleString("en-IN")}`,   sub: `${payments.filter(p => p.status === "Pending").length} transactions`,  icon: "bi-clock-fill",           color: "#d97706" },
          { label: "Refunded",        val: `₹${totalRefunded.toLocaleString("en-IN")}`,  sub: `${payments.filter(p => p.status === "Refunded").length} transactions`, icon: "bi-arrow-counterclockwise", color: "#7c3aed" },
          { label: "Failed",          val: `${totalFailed} txns`,                         sub: "Requires attention",                                                   icon: "bi-x-circle-fill",         color: "#dc2626" },
        ].map(s => (
          <div key={s.label} className="pay-stat-card">
            <div className="pay-stat-label"><i className={`bi ${s.icon}`} style={{ color: s.color, marginRight: 5 }}></i>{s.label}</div>
            <div className="pay-stat-val">{s.val}</div>
            <div className="pay-stat-sub">{s.sub}</div>
          </div>
        ))}
      </div>

      {/* Table Card */}
      <div className="pay-card">
        <div className="pay-card-head">
          <div className="pay-card-title"><i className="bi bi-credit-card-2-front-fill"></i> Transactions</div>
          <div className="pay-filter-row">
            <select className="pay-filter-select" value={filterStatus} onChange={e => setFilterStatus(e.target.value)}>
              {["All", "Paid", "Pending", "Failed", "Refunded"].map(s => <option key={s}>{s}</option>)}
            </select>
            <select className="pay-filter-select" value={filterMethod} onChange={e => setFilterMethod(e.target.value)}>
              {["All", "UPI", "Card", "NetBanking", "COD", "Wallet"].map(m => <option key={m}>{m}</option>)}
            </select>
          </div>
        </div>
        <div style={{ padding: "0 4px" }}>
          <DataTable
            columns={cols}
            rows={filtered}
            rowKey={(r) => r.id}
          />
        </div>
      </div>

      {/* Refund Confirm Modal */}
      {refundTarget && (
        <div className="pay-modal-overlay" onClick={() => setRefundTarget(null)}>
          <div className="pay-modal" onClick={e => e.stopPropagation()}>
            <div className="pay-modal-head">
              <div className="pay-modal-title">Confirm Refund</div>
              <button className="pay-modal-close" onClick={() => setRefundTarget(null)}>✕</button>
            </div>
            <div className="pay-modal-body">
              {[
                ["Order",    refundTarget.orderId],
                ["Customer", refundTarget.customer],
                ["Amount",   `₹${refundTarget.amount.toLocaleString("en-IN")}`],
                ["Method",   refundTarget.method],
                ["Txn ID",   refundTarget.txnId],
              ].map(([l, v]) => (
                <div key={l} className="pay-detail-row">
                  <div className="pay-detail-label">{l}</div>
                  <div className="pay-detail-val">{v}</div>
                </div>
              ))}
              <div style={{ marginTop: 14, padding: "10px 14px", background: "#fff7ed", borderRadius: 10, border: "1px solid #fed7aa", fontSize: 12, color: "#9a3412" }}>
                <i className="bi bi-exclamation-triangle-fill" style={{ marginRight: 6 }}></i>
                This action will initiate a refund. Amount will be credited within 5–7 business days.
              </div>
            </div>
            <div className="pay-modal-foot">
              <button className="pay-btn-cancel" onClick={() => setRefundTarget(null)}>Cancel</button>
              <button className="pay-btn-confirm" onClick={doRefund}><i className="bi bi-arrow-counterclockwise"></i> Process Refund</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
